import { __awaiter, __generator } from "tslib";
import { fetchCartSetting } from '../site-settings/fetch-cart-setting';
import { fetchToken } from './fetch-token';
import { combineUrl } from './utilities/combine-url';
import { getGoogleAnalytics } from './utilities/get-google-analytics';
export var fetchCheckoutUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
    var cartSetting, token, checkoutUrl, gaValue;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchCartSetting()];
            case 1:
                cartSetting = _a.sent();
                if (!cartSetting) {
                    return [2 /*return*/, Promise.resolve('')];
                }
                return [4 /*yield*/, fetchToken()];
            case 2:
                token = _a.sent();
                if (!token) {
                    return [2 /*return*/, Promise.resolve('')];
                }
                checkoutUrl = combineUrl(cartSetting.checkoutUrl, {
                    currency: cartSetting.currency || '',
                    locale: cartSetting.marketLocale || '',
                    token: token.access_token || '',
                });
                gaValue = getGoogleAnalytics();
                if (gaValue) {
                    checkoutUrl += "&" + gaValue;
                }
                return [2 /*return*/, checkoutUrl];
        }
    });
}); };
